export enum ImageType {
    IMAGE_MAP = 'image-map',
    IMAGE_LEGEND = 'image-legend',
    IMAGE_ALL = 'image-all',
}
